import React from "react";
import "./profile.css";

export default function Profile({ user }) {
  return (
    <div className="profile">
      <div className="profile-top">
        <div className="profile-name">
          <div className="hello">Hello! </div>
          <div className="profile-name-inner">
            I'm <label>{user.name}</label>
          </div>
        </div>
        <div className="profile-title">{user.role}</div>
        <img src={user.profile_picture} className="profile-img"></img>
      </div>
      <div className="profile-mid">
        <a href={user.resume} target="_blank" className="resume-btn">
          <i class="fa-solid fa-cloud-arrow-down"></i> RESUME
        </a>
        <div className="profile-mid-line"></div>
        <div className="about-title">About</div>
        {user.about.map((item, index) =>
          index % 2 === 0 ? (
            <span>{item}</span>
          ) : (
            <span style={{ color: "goldenrod" }}> {item} </span>
          )
        )}
      </div>
      <div className="profile-bottom">
        <div className="contact-heading">
          <div className="contact-title">Contact Me</div>
        </div>
        <div className="contact-body">
          <div className="contact-item">
            {" "}
            <i class="fa-solid fa-envelope"></i>
            {user.email.split("@")[0]}
            <img
              style={{ height: "15px" }}
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFCElEQVR4nO1Z24tbRRg/eKmKF7xVsc3m+xJDq+vtQa2XFy9/goj4JLUPQvVRYa2C+tCu4INaahFBaLuZSSB17VpBcEWWvgjWbm/ETWZ22+22grbrlQrd+tDI7yTZTk7OnDM5yW4V8sGwh8ztu3+/b9bz+tSnPnVNtbe9y3SeHlWS3tCSR5XgspL8u5b0Dwa+/d8Ef6YEbVIFfgR7vEtNOp9LKcHvask/acm1ToaSdEpLHlY7U6uXnfGpXatuUZI/1oLOd8p4myCCFpTg7eVS6uZlYV5Jel5L/rVbxtuGoPnpAj+3ZIxPTHhX+FrvNeOybXyEu3rK/MlS6hol6ctlYL7WcKu9uLOHmndjXkme1JLfms7Tk1VJdx0euf1aDHzjN8w11jgJMdELS8S5jRJ8QUnaXcnzWtczsbaeUvlCTFxs60XARmnqOPJ/0vOni+nHteDZyDvymWcTp8robEP7qnLNreYepEKdpw1K0piWVNWS/64PqmrBe7SkF+dk+iZzjy7lVuKsCFc6E9zTA9ehfeXS4IpAkL+pJP3l4Nt/ohqbQVouDa6IEqJjV0KFtRYpmLyUW9lcWykMrNKS9ifINoeO7cqmTYsrwTMWoRc6qtgNeBAasKbP49AGJEiWLiWdMhlDTFgDW/AWJ+ZrJe9yG7ZBtml1Gz4QIuRBJfkFWNFPwTtTq+H7WpCC6yCtNkBf0x33z+6gqxetL3nUcvecEwCEhm3aN1MlfD5ES5uhAJtimnP6q9xVgb1Di+cW6W67xTLrYgVo1Y65mSfNbINgDMy/H3u4qajWvX+YmQbxYRFiyOXgUBOiii6uydOGYGCbWWla0mNgooE0D4bVipBAXW8o8Z04F7YSGo+wzYACxgVjgctfXZwb4QfaMpig89VC5v4oAbTkz5tz1UL66XAl0tF4Cwj+LWzzVDGz5uIaUi3CFQbuuagA2mvR3li0AFRtziHWwjMRzTsIEJ7/y6XB64w1Z805ZBbDOqfDkwCdiRRA0NnmHO6ynLGQWIDKp2uvtwlgCmcXgH+OtgDX4uYdBejchWZGsvcaAnzh5EIBRSmDuUYtSuZC1iAW9JQh5J6Adl+LC+KKyN7XqmH6JiDAeHPuR8GUPIhd0igqa6t2T5hptP7EwpNK8jlUazyjBO8Bk0rQONxRSfraxEVa0sYu0ihtiitkKDohheyD2MM9zzvwyYNXRiown7sBsCFxIYO2nKBEuKDDNigBXKQFvacFfwsmrcwLGrcwX6sUsg/FCgDAZEOYaAOb6wDAtKAfQvz0MKoqXAKYx//ruxwdNfz9ZFWkX6kUiY01GyM07w7mfE1IHrZZAZC3V3BadzIEb3ZivmHKFNKaRRMnZkayt7U0NIK+X0rmlaAF3OMsgK9dwdtdW0rfnSS9DlS5NELQVi9RUy9oPkoIs7U0stN6ADMtuNKo2Gjsj/nPKJJfQj2JClTdbvHTiZp6EN4qYy44bsaEK6Fyd+A+z3jdEN4qoy/we9hRdFLuZ9LLjsx/6HVLfl9rgcgh4xCaEeB5PCcC5AGp6uLAnVryE5hTgr+LfZGTdexkqykdk9/AuwvRfdaRNNazx91AJd229ALQ1p5pPozwVmnD/F1pXdAvXQesKyGtwRq2YteZu/A5aH12B93oLTfVqzBvAbZJ4OdzgAdT+fQd3qWmOgDMrKtXY9rtAzd0dmhs/OF/H6nP8VA1n3n4P/Fv1j71yfv/07+Ae6CAwDtzNgAAAABJRU5ErkJggg=="
            ></img>
            {user.email.split("@")[1]}
          </div>
          <div className="contact-item">
            <i class="fa-solid fa-phone"></i> {user.phone}
          </div>
          <div className="contact-item">
            <i class="fa-solid fa-location-dot"></i> {user.location}
          </div>
        </div>
        <div className="socials">
          <div className="socials-inner">
            {user.social_links.map((item, index) =>
              item.icon ? (
                <a href={item.link} target="_blank" className="social-item">
                  <i class={`fa-brands ${item.icon}`}></i>
                </a>
              ) : (
                <a href={item.link} target="_blank" className="social-item">
                  <img src={item.img}></img>
                </a>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
